import { useMargin, useClassNames } from '@magnetic/hooks';
import { consoleWarn } from '@magnetic/lib';
import React, { useMemo } from 'react';
import './styles.css.js';
import '@magnetic/theme';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const sizeMap = {
  primary: "primary",
  xl: "primary",
  lg: "primary",
  md: "primary",
  sm: "section",
  section: "section",
  xs: "sub-section",
  "sub-section": "sub-section",
  xxs: "smallest",
  smallest: "smallest",
  h1: "primary",
  h2: "section",
  h3: "sub-section",
  h4: "smallest"
};
const tagMap = {
  primary: "h1",
  section: "h2",
  "sub-section": "h3",
  smallest: "h4"
};
const Heading = /* @__PURE__ */ __name(({
  as,
  children,
  className,
  margin,
  size = "section",
  ...rest
}) => {
  const marginClassNames = useMargin(margin);
  const computedClassName = useClassNames(
    "mds-heading",
    `mds-heading-size-${sizeMap[size]}`,
    marginClassNames,
    className
  );
  const Component = useMemo(() => as != null ? as : tagMap[sizeMap[size]], [as, size]);
  consoleWarn({
    prop: size,
    propValues: [
      "xxs",
      "xxs",
      "xs",
      "sm",
      "md",
      "lg",
      "xl",
      "h1",
      "h2",
      "h3",
      "h4"
    ],
    message: "The use of t-shirt sizes (sm, md, lg, etc) and h sizes (h1, h2, h3, etc) in the `Heading` component is deprecated and will be removed in a future major release of Magnetic in order to align terminology between design and engineering. Please use primary through smallest as they appear in your Figma designs in the inspector tab under the Typography section."
  });
  return /* @__PURE__ */ React.createElement(Component, {
    className: computedClassName,
    role: "heading",
    ...rest
  }, children);
}, "Heading");

export { Heading };
//# sourceMappingURL=index.js.map
